// The form that creates a line, and the account's lines kept where everything else can read them.
//
// It used to paint the list as well, in `renderLinesList`, building every row out of DOM nodes by
// hand. /lines paints them with `components/lines/MyLines.tsx` now — grouped by opening, which is
// the only way a repertoire of thirty lines reads as anything — so what is left here is the form,
// and reading the lines into the store for whoever shows them.

import * as api from "../services/api.ts";
import * as ownLines from "../services/ownLines.ts";

// DOM elements
let linesAuthNotice = null;
let addLineAuthNotice = null;
let addLineForm = null;
let lineNameInput = null;
let lineFenInput = null;
let lineUciMovesInput = null;
let lineColorSelect = null;
let useCurrentPositionBtn = null;

// Callbacks
let onUseCurrentPosition = null;
let onCloseDropdown = null;
let onLinesChanged = null;

// State
let isLoggedIn = false;
let lines = [];

export function initLines(elements, callbacks = {}) {
  linesAuthNotice = elements.linesAuthNotice;
  addLineAuthNotice = elements.addLineAuthNotice;
  addLineForm = elements.addLineForm;
  lineNameInput = elements.lineNameInput;
  lineFenInput = elements.lineFenInput;
  lineUciMovesInput = elements.lineUciMovesInput;
  lineColorSelect = document.getElementById("lineColor");
  useCurrentPositionBtn = elements.useCurrentPositionBtn;
  onUseCurrentPosition = callbacks.onUseCurrentPosition;
  onCloseDropdown = callbacks.onCloseDropdown;
  onLinesChanged = callbacks.onLinesChanged;

  addLineForm?.addEventListener("submit", handleAddLine);
  useCurrentPositionBtn?.addEventListener("click", handleUseCurrentPosition);
}

export function setLoggedIn(loggedIn) {
  isLoggedIn = loggedIn;
  updateAuthUI();
  loadLinesList();
}

function updateAuthUI() {
  // My Lines auth notice
  if (linesAuthNotice) {
    linesAuthNotice.classList.toggle("hidden", isLoggedIn);
  }
  // Add Line auth notice
  if (addLineAuthNotice) {
    addLineAuthNotice.classList.toggle("hidden", isLoggedIn);
  }
  // Hide form if not logged in
  if (addLineForm) {
    addLineForm.classList.toggle("hidden", !isLoggedIn);
  }
}

function handleUseCurrentPosition() {
  // Delegate to the callback which updates the line board
  if (onUseCurrentPosition) {
    onUseCurrentPosition();
  }
}

/** Reads them into the store, which is where every page that shows them looks. */
export async function loadLinesList() {
  if (!isLoggedIn) {
    lines = [];
    ownLines.forget();
    if (onLinesChanged) onLinesChanged();
    return;
  }

  try {
    lines = await ownLines.refresh();
  } catch (err) {
    console.error("Failed to load lines", err);
    lines = [];
  }
  if (onLinesChanged) onLinesChanged();
}

async function handleAddLine(event) {
  event.preventDefault();

  const name = lineNameInput?.value?.trim();
  const fen = lineFenInput?.value?.trim();
  const uciMoves = lineUciMovesInput?.value?.trim();
  const color = lineColorSelect?.value || "white";

  if (!name) {
    alert("Please enter a name for the line.");
    return;
  }
  if (!fen) {
    alert("Please make some moves on the board or use the main board position.");
    return;
  }

  try {
    await api.createLine(name, fen, uciMoves || "", color, "manual");
    // Read back rather than pushed: the line comes from the server with the opening it belongs to,
    // which is what the list is grouped by
    await loadLinesList();
    addLineForm.reset();
    // Close the dropdown after saving
    if (onCloseDropdown) {
      onCloseDropdown();
    }
  } catch (err) {
    console.error("Failed to save line", err);
    alert(`Failed to save line: ${err.message}`);
  }
}

export function getLines() {
  return lines;
}

export function getActiveLines() {
  return lines.filter((l) => l.active);
}
